/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedMeasurementUnitProvider_user$ref = any;
type SbSharedRefineMenuDimensionUnitRadioSelect_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuInputRangeDimensions_user$ref: FragmentReference;
export type SbSharedRefineMenuInputRangeDimensions_user = {|
  +$fragmentRefs: SbSharedMeasurementUnitProvider_user$ref & SbSharedRefineMenuDimensionUnitRadioSelect_user$ref,
  +$refType: SbSharedRefineMenuInputRangeDimensions_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuInputRangeDimensions_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedMeasurementUnitProvider_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDimensionUnitRadioSelect_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c857af47a8a37f29367946d18603b847';
module.exports = node;
